
import { Component, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { HttpService } from '../services/http.service';
import { AuthenService } from '../services/authen.service';
import { HelperService } from '../services/helper.service';
import { SidebarService } from './sidebar.service';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.html',
    styleUrls: ['./sidebar.scss'],
    animations: [
        trigger('slide', [
            state('up', style({ height: 0 })),
            state('down', style({ height: '*' })),
            transition('up <=> down', animate(200))
        ])
    ]
})
export class SidebarComponent implements OnInit {
    menus = [];

    constructor(public sidebar: SidebarService, private http: HttpService, public auth: AuthenService, public helper: HelperService) {
        this.menus = sidebar.getMenuList();
    }

    ngOnInit() {
        this.load();
    }

    load() {
        //console.log('load sidebar');

        this.http.get('api/Sidebar/Get', res => {
            //console.log(res.Result);
            this.sidebar.build(res.Result);
            this.menus = this.sidebar.getMenuList();
            this.checkScreenSize();
        });
    }

    getSideBarState() {
        return this.sidebar.getSidebarState();
    }

    getUserName() {/*
        let name = this.auth.getFullName();
        let fields = name.split(" ");
        let worlds = [];
        let cnt = fields.length;

        fields.forEach(p => {
            if (p !== '')
                worlds.push(p);
        });

        cnt = worlds.length;

        if (cnt > 2)
            return worlds[cnt - 2] + ' ' + worlds[cnt - 1];
        else
            return name;
            */
        return 'Tran Minh Thanh';
    }

    reset(menus: any) {
        menus.forEach(p => {
            p.active = false;

            if (p.type === 'dropdown') {
                this.reset(p.submenus)
            }
        });
    }

    toggle(currentMenu: any, menus: any) {
        menus.forEach(p => {
            if (p === currentMenu) {
                currentMenu.active = !currentMenu.active;
                this.sidebar.getSiteMap(currentMenu);
            } else {
                p.active = false;
            }

            if (p.type === 'dropdown') {
                this.toggle(currentMenu, p.submenus)
            }
        });
    }

    toggleHeader(currentMenu: any) {
        this.menus.forEach(p => {
            if (p.type === 'dropdown') {
                if (p === currentMenu) {
                    currentMenu.active = !currentMenu.active;
                } else {
                    p.active = false;
                }
            }
        });
    }

    toggleDrop(currentMenu: any, subMenus: any[]) {
        subMenus.forEach(p => {
            if (p.type === 'dropdown') {
                if (p === currentMenu) {
                    currentMenu.active = !currentMenu.active;
                } else {
                    p.active = false;
                }
            }
        });
    }

    toggle2(currentMenu: any, menus: any) {
        menus.forEach(p => {
            if (p.type === 'dropdown') {
                this.toggle2(currentMenu, p.submenus)
            }
            else {
                if (p === currentMenu) {
                    currentMenu.active = !currentMenu.active;
                    this.sidebar.getSiteMap(currentMenu);
                } else {
                    p.active = false;
                }
            }
        });
    }

    getState(currentMenu) {
        if (currentMenu.active) {
            return 'down';
        } else {
            return 'up';
        }
    }

    isToggled() {
        return this.sidebar.getSidebarState();
    }

    onMouseEnter() {
        //this.sidebar.slide(false);
    }

    onMouseLeave() {
       // this.sidebar.slide(true);
    }


    onLogoClick() {
        this.sidebar.toggle();
    }


    checkScreenSize(): void {
        const mobileWidth = 768; // Định nghĩa ngưỡng màn hình mobile
        if (window.innerWidth < mobileWidth)
        {
            this.sidebar.toggle();
        }
    }





}
